/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { EX, EXERCISE_GUIDE, TABATA_EX_BASE } from './exercises.js';

// ─── CONSTANTES ───────────────────────────────────────────────────────────────
const LS_SESSION_KEY = "calestan_session_state";

const ALL_MUSCLES = [
  "Pectoraux","Dos","Épaules","Biceps","Triceps",
  "Quadriceps","Ischio-jambiers","Fessiers","Mollets",
  "Abdominaux","Trapèzes","Avant-bras","Cardio / Full body",
];

// Formate les secondes en mm:ss
const fmt = (s) => {
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}:${String(m).padStart(2,"0")}:${String(sec).padStart(2,"0")}`;
  return `${String(m).padStart(2,"0")}:${String(sec).padStart(2,"0")}`;
};

// ─── UTILS AUDIO ─────────────────────────────────────────────────────────────
let _ctx = null;
const getCtx = () => {
  if (!_ctx || _ctx.state === "closed") _ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
};
if (typeof window !== "undefined") {
  const unlock = () => {
    try { if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)(); if (_ctx.state === "suspended") _ctx.resume(); } catch(e) {}
    document.removeEventListener("touchstart", unlock);
    document.removeEventListener("click", unlock);
  };
  document.addEventListener("touchstart", unlock, { passive: true });
  document.addEventListener("click", unlock);
}
const beep = (freq, dur, vol=0.4, type="sine") => {
  try {
    const c = getCtx(); const o = c.createOscillator(), g = c.createGain();
    o.connect(g); g.connect(c.destination); o.frequency.value = freq; o.type = type;
    const t = c.currentTime;
    g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.001, t+dur);
    o.start(t); o.stop(t+dur+0.01);
  } catch(e) {}
};
const duckAudio = (duck) => {
  try {
    if ('mediaSession' in navigator) navigator.mediaSession.playbackState = duck ? 'playing' : 'paused';
  } catch(e) {}
};
const playCountdown = (secondsRemaining) => {
  try {
    const c = getCtx();
    const freq = 600;
    if (secondsRemaining === 3 || secondsRemaining === 2 || secondsRemaining === 1) {
      duckAudio(true);
      const o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination);
      o.frequency.value = freq; o.type = "square";
      const t = c.currentTime;
      g.gain.setValueAtTime(0.6, t); g.gain.exponentialRampToValueAtTime(0.001, t+0.15);
      o.start(t); o.stop(t+0.18);
      setTimeout(() => duckAudio(false), 180);
    } else if (secondsRemaining === 0) {
      duckAudio(true);
      const o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination);
      o.frequency.value = freq; o.type = "square";
      const t = c.currentTime;
      g.gain.setValueAtTime(0.7, t); g.gain.exponentialRampToValueAtTime(0.001, t+0.8);
      o.start(t); o.stop(t+0.85);
      setTimeout(() => duckAudio(false), 850);
    }
  } catch(e) {}
};
const speak = t => {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(t);
  u.lang = "fr-FR"; u.rate = 0.95;
  window.speechSynthesis.speak(u);
};

// ─── UI ATOMS ─────────────────────────────────────────────────────────────────
const Tag = ({label,color,bg}) => (
  <span style={{background:bg,color,fontSize:11,padding:"3px 10px",borderRadius:20,fontWeight:700}}>{label}</span>
);
const MM = {
  "Pectoraux":{color:"#ef4444",bg:"rgba(239,68,68,0.12)"},
  "Dos":{color:"#8b5cf6",bg:"rgba(139,92,246,0.12)"},
  "Épaules":{color:"#eab308",bg:"rgba(234,179,8,0.12)"},
  "Biceps":             {color:"#f97316",bg:"rgba(249,115,22,0.12)"},
  "Triceps":            {color:"#06b6d4",bg:"rgba(6,182,212,0.12)"},
  "Quadriceps":         {color:"#3b82f6",bg:"rgba(59,130,246,0.12)"},
  "Ischio-jambiers":    {color:"#10b981",bg:"rgba(16,185,129,0.12)"},
  "Fessiers":           {color:"#ec4899",bg:"rgba(236,72,153,0.12)"},
  "Mollets":            {color:"#14b8a6",bg:"rgba(20,184,166,0.12)"},
  "Abdominaux":         {color:"#f59e0b",bg:"rgba(245,158,11,0.12)"},
  "Trapèzes":           {color:"#a78bfa",bg:"rgba(167,139,250,0.12)"},
  "Avant-bras":         {color:"#fb923c",bg:"rgba(251,146,60,0.12)"},
  "Cardio / Full body": {color:"#84cc16",bg:"rgba(132,204,22,0.12)"},
};
const mkBtn = C => ({children,onClick,variant="primary",small,full,disabled,style:s={}}) => {
  const v = {
    primary:{background:`linear-gradient(135deg,${C.accent},${C.accent2})`,color:"white",boxShadow:`0 4px 20px ${C.glow}`},
    ghost:  {background:C.faint,color:C.muted,border:`1px solid ${C.border}`},
    outline:{background:"transparent",color:C.accent,border:`1px solid ${C.accent}`},
    danger: {background:"rgba(239,68,68,0.1)",color:C.red,border:"1px solid rgba(239,68,68,0.25)"},
  };
  return <button onClick={disabled?undefined:onClick} style={{border:"none",fontWeight:800,borderRadius:12,cursor:disabled?"default":"pointer",opacity:disabled?0.35:1,fontSize:small?13:15,letterSpacing:0.4,padding:small?"8px 16px":"14px 20px",width:full?"100%":undefined,transition:"all 0.15s",...v[variant],...s}}>{children}</button>;
};

function MovementGuide({exercise, onClose, C, inlineMode=false}) {
  // Support both {name, detail} objects and plain string (from inlineMode usage)
  const exName = typeof exercise === "string" ? exercise : exercise?.name;
  const exDetail = typeof exercise === "string" ? null : exercise?.detail;
  const guide = EXERCISE_GUIDE[exName];
  
  // Exercices sensibles nécessitant un avertissement de sécurité
  const riskyExercises = [
    "Squat barre",
    "Squat avant",
    "Développé couché barre",
    "Développé couché haltères",
    "Développé incliné barre",
    "Soulevé de terre",
    "Soulevé de terre roumain",
    "Développé militaire barre",
    "Back squat",
    "Front squat",
    "Nordic curl",
    "Toes to bar",
    "Pompes claquées",
    "Fentes bulgares",
    "Snatch kettlebell",
  ];
  
  const isRisky = riskyExercises.some(r => exName?.toLowerCase().includes(r.toLowerCase()));

  const content = (
    <div style={{padding: inlineMode?"0":"0 20px 60px"}}>
      {!inlineMode&&(
        <div style={{background:C.faint,borderRadius:16,marginBottom:16,height:160,border:`1px solid ${C.border}`}}/>

      )}

      {exDetail&&(
        <div style={{background:`${C.accent}12`,borderRadius:12,padding:"10px 14px",marginBottom:16,border:`1px solid ${C.accent}30`}}>
          <p style={{color:C.accent,fontWeight:700,fontSize:11,margin:"0 0 3px",letterSpacing:1}}>MUSCLES CIBLÉS</p>
          <p style={{color:C.text,fontSize:13,margin:0,lineHeight:1.5}}>{exDetail}</p>
        </div>
      )}

      {guide ? (
        <>
          <p style={{color:C.muted,fontSize:10,letterSpacing:3,margin:"0 0 12px"}}>EXÉCUTION</p>
          <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
            {guide.steps.map((step,i)=>(
              <div key={i} style={{display:"flex",gap:12,alignItems:"flex-start"}}>
                <div style={{width:26,height:26,borderRadius:"50%",background:`${C.accent}20`,border:`1px solid ${C.accent}50`,display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,flexShrink:0,marginTop:1}}>
                  <span style={{color:C.accent,fontSize:12,fontWeight:900}}>{i+1}</span>
                </div>
                <p style={{color:C.text,fontSize:14,lineHeight:1.55,margin:0,flex:1}}>{step}</p>
              </div>
            ))}
          </div>
          <div style={{background:C.card,borderRadius:12,padding:"12px 14px",border:`1px solid ${C.border}`,display:"flex",gap:10,alignItems:"flex-start",marginBottom:isRisky?12:0}}>
            <p style={{color:C.muted,fontSize:13,margin:0,lineHeight:1.55}}>{guide.tips}</p>
          </div>
          {isRisky&&(
            <div style={{background:"#FEE",borderRadius:12,padding:"12px 14px",border:"2px solid #F44",display:"flex",gap:10,alignItems:"flex-start"}}>
              <div>
                <p style={{color:"#C00",fontWeight:800,fontSize:13,margin:"0 0 4px"}}>ATTENTION - Exercice à risque</p>
                <p style={{color:"#800",fontSize:12,margin:0,lineHeight:1.55}}>Cet exercice présente des risques accrus de blessure. Assurez-vous de maîtriser parfaitement la technique avant d'augmenter les charges. En cas de doute, demandez conseil à un coach.</p>
              </div>
            </div>
          )}
        </>
      ):(
        <div style={{background:C.card,borderRadius:12,padding:"16px",border:`1px solid ${C.border}`}}>
          <p style={{color:C.muted,fontSize:13,margin:0,lineHeight:1.6}}>Description bientôt disponible.</p>
        </div>
      )}
    </div>
  );

  if(inlineMode){
    return(
      <div style={{background:C.card,borderRadius:18,border:`1px solid ${C.accent}30`,padding:"16px",marginBottom:16}}>
        <p style={{color:C.accent,fontSize:10,letterSpacing:3,margin:"0 0 12px",fontWeight:700}}>COMMENT RÉALISER CET EXERCICE</p>
        {content}
      </div>
    );
  }
  
  return (
    <div style={{position:"fixed",inset:0,overscrollBehavior:"none",background:C.bg,zIndex:500,display:"flex",flexDirection:"column",overflowY:"auto"}}>
      <div style={{background:`linear-gradient(180deg,${C.accent}18,transparent)`,padding:"calc(env(safe-area-inset-top) + 20px) 20px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{flex:1,minWidth:0,paddingRight:12}}>
          <p style={{color:C.accent,fontSize:10,letterSpacing:3,margin:"0 0 6px",fontWeight:700}}>COMMENT RÉALISER</p>
          <h2 style={{color:C.text,fontSize:20,fontWeight:900,margin:0,lineHeight:1.3}}>{exName}</h2>
        </div>
        <button onClick={onClose} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:"50%",width:40,height:40,color:C.text,fontSize:22,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,flexShrink:0}}>×</button>
      </div>
      {content}
    </div>
  );
}

function RestTimer({duration,onDone,voiceEnabled,remainingSets,exerciseName,nextExercise,onAddTime,exRest,onAdjustRest,cardHeight,C}) {
  const endTime = useRef(Date.now() + duration*1000);
  // Exposer addTime pour les boutons +/-
  if(onAddTime) onAddTime.current=(secs)=>{endTime.current+=secs*1000;};
  const [t,setT] = useState(duration);
  const fired = useRef(false);
  const lastTick = useRef(-1);
  const circ = 2*Math.PI*52;
  useEffect(() => {
    getCtx();
    if (voiceEnabled) speak(`Repos. ${duration} secondes.`);
    const id = setInterval(() => {
      const remaining = Math.max(0, Math.round((endTime.current - Date.now()) / 1000));
      setT(remaining);
      if (remaining>=0&&remaining<=3&&remaining!==lastTick.current) { lastTick.current=remaining; playCountdown(remaining); }
      if (remaining===0&&!fired.current) {
        fired.current=true;
        beep(600,0.6,0.6,"sine");
        if(voiceEnabled)setTimeout(()=>speak("Série suivante !"),700);
        setTimeout(onDone,1000);
      }
    }, 250);
    return () => clearInterval(id);
  }, []);
  const pct = t/duration;
  const col = t<=5?C.red:t<=15?C.yellow:C.accent;
  // Prochain contenu à afficher
  const hasNext = remainingSets&&remainingSets.length>0;
  const showNextEx = !hasNext&&nextExercise;
  return (
    <div style={{background:`linear-gradient(135deg,${C.accent}10,${C.accent2}06)`,border:`1px solid ${C.accent}30`,borderRadius:22,padding:"22px 18px 18px",marginBottom:14,display:"flex",flexDirection:"column",minHeight:cardHeight||260}}>
      {/* Barre progression haut */}
      <div style={{height:5,background:C.faint,borderRadius:999,marginBottom:20,overflow:"hidden"}}>
        <div style={{height:"100%",width:`${pct*100}%`,background:col,borderRadius:999,transition:"width 1s linear"}}/>
      </div>

      <div style={{display:"flex",alignItems:"center",gap:20,marginBottom:18}}>
        {/* Cercle timer */}
        <div style={{position:"relative",width:120,height:120,flexShrink:0}}>
          <svg width="120" height="120" style={{position:"absolute",top:0,left:0,transform:"rotate(-90deg)"}}>
            <circle cx="60" cy="60" r="52" fill="none" stroke={C.faint} strokeWidth="7"/>
            <circle cx="60" cy="60" r="52" fill="none" stroke={col} strokeWidth="7" strokeLinecap="round"
              strokeDasharray={circ} strokeDashoffset={circ-pct*circ}
              style={{transition:"stroke-dashoffset 1s linear,stroke 0.3s"}}/>
          </svg>
          <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <span style={{color:t<=5?col:C.text,fontSize:42,fontWeight:900,lineHeight:1,fontVariantNumeric:"tabular-nums"}}>{t}</span>
            <span style={{color:C.muted,fontSize:11,marginTop:2}}>secondes</span>
          </div>
        </div>

        {/* Contenu droite */}
        <div style={{flex:1,minWidth:0}}>
          <p style={{color:C.muted,fontSize:10,letterSpacing:3,margin:"0 0 8px",fontWeight:700}}>REPOS</p>
          {hasNext?(
            <>
              <p style={{color:C.muted,fontSize:11,margin:"0 0 6px"}}>{exerciseName}</p>
              <div style={{maxHeight:108,overflowY:"auto"}}>
              {remainingSets.map((s,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 10px",marginBottom:4,
                  background:i===0?`${C.accent}15`:C.faint,borderRadius:9,
                  border:i===0?`1px solid ${C.accent}30`:"none"}}>
                  <span style={{color:i===0?C.accent:C.muted,fontSize:11,fontWeight:700}}>→</span>
                  <span style={{color:i===0?C.text:C.muted,fontWeight:i===0?800:500,fontSize:13}}>
                    {s.reps} reps{s.weight>0?` · ${s.weight} kg`:""}
                  </span>
                </div>
              ))}
              </div>
            </>
          ):showNextEx?(
            <>
              <p style={{color:C.muted,fontSize:10,letterSpacing:2,margin:"0 0 6px"}}>PROCHAIN EXERCICE</p>
              <div style={{background:`${C.accent}10`,border:`1px solid ${C.accent}28`,borderRadius:10,padding:"10px 12px"}}>
                <p style={{color:C.accent,fontWeight:800,fontSize:14,margin:"0 0 6px",lineHeight:1.35}}>{nextExercise.name}</p>
                {(nextExercise.plannedSets||[]).map((s,i)=>(
                  <p key={i} style={{color:i===0?C.text:C.muted,fontSize:12,margin:"0 0 2px",fontWeight:i===0?700:400}}>
                    {i+1}. {s.reps} reps{s.weight>0?` · ${s.weight} kg`:""}
                  </p>
                ))}
              </div>
            </>
          ):(
            <p style={{color:C.text,fontWeight:700,fontSize:15,margin:0}}>Dernier exercice terminé</p>
          )}
        </div>
      </div>

      <div style={{marginTop:"auto",paddingTop:12}}>
        {onAdjustRest&&exRest!=null&&(
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,marginBottom:10}}>
            <button onClick={()=>onAdjustRest(-15)}
              style={{background:C.faint,border:`1px solid ${C.border}`,borderRadius:8,width:32,height:32,color:C.muted,fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>−</button>
            <span style={{color:C.muted,fontSize:11,fontWeight:600,minWidth:60,textAlign:"center"}}>Repos {Math.floor(exRest/60)>0?Math.floor(exRest/60)+"min ":""}{exRest%60>0?exRest%60+"s":""}</span>
            <button onClick={()=>onAdjustRest(+15)}
              style={{background:C.faint,border:`1px solid ${C.border}`,borderRadius:8,width:32,height:32,color:C.accent,fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>+</button>
          </div>
        )}
        <button onClick={()=>{onDone();}}
          style={{width:"100%",padding:"12px",background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.muted,fontWeight:800,fontSize:14,cursor:"pointer"}}>
          Passer le repos →
        </button>
      </div>
    </div>
  );
}

function NumField({label,val,setVal,step,min,dec,editing,setEditing,raw,setRaw,onCommit,C}) {
  return (
    <div>
      <label style={{color:C.muted,fontSize:11,letterSpacing:2,display:"block",marginBottom:10}}>{label}</label>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <button onMouseDown={e=>e.preventDefault()} onClick={()=>{const nv=parseFloat(Math.max(min,val-step).toFixed(dec));setVal(nv);setRaw(String(nv));}} style={{background:C.faint,border:"none",borderRadius:10,width:46,height:46,color:C.text,fontSize:24,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>−</button>
        {editing
          ?<input type="text" inputMode="decimal" value={raw} autoFocus
              onChange={e=>{
                const cleaned=e.target.value.replace(/[,،٫]/g,".");
                setRaw(cleaned);
              }}
              onBlur={onCommit}
              onKeyDown={e=>{if(e.key==="Enter")onCommit();}}
              style={{background:C.surface,border:`1px solid ${C.accent}`,borderRadius:10,color:C.text,fontSize:26,fontWeight:900,flex:1,textAlign:"center",padding:"6px 0",outline:"none",width:"100%"}}/>
          :<span onClick={()=>{setEditing(true);setRaw(val===0?"":String(val));}} style={{color:C.text,fontSize:32,fontWeight:900,flex:1,textAlign:"center",cursor:"text",borderBottom:`1px dashed ${C.muted}`}}>{dec===0?val:val.toFixed(dec)}</span>
        }
        <button onMouseDown={e=>e.preventDefault()} onClick={()=>{const nv=parseFloat((val+step).toFixed(dec));setVal(nv);setRaw(String(nv));}} style={{background:C.faint,border:"none",borderRadius:10,width:46,height:46,color:C.accent,fontSize:24,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>+</button>
      </div>
    </div>
  );
}

function SetModal({setIdx,exercise,defaultReps,defaultWeight,prevSet,suggestion,onConfirm,onClose,C}) {
  const [reps,setReps]=useState(defaultReps??10);
  const [weight,setWeight]=useState(defaultWeight??0);
  const [editW,setEditW]=useState(false);
  const [editR,setEditR]=useState(false);
  const [rawW,setRawW]=useState(defaultWeight?String(defaultWeight):"");
  const [rawR,setRawR]=useState(String(defaultReps??10));
  const BtnC=mkBtn(C);
  const commitW=()=>{const normalized=rawW.replace(",",".");const v=parseFloat(normalized);const final=(!rawW||rawW.trim()===""||isNaN(v)||v<0)?0:parseFloat(v.toFixed(1));setWeight(final);setRawW(final===0?"":String(final));setEditW(false);};
  const commitR=()=>{const v=parseInt(rawR);if(!isNaN(v)&&v>=1)setReps(v);else setRawR(String(reps));setEditR(false);};
  return (
    <div style={{position:"fixed",inset:0,overscrollBehavior:"none",background:"rgba(0,0,0,0.88)",backdropFilter:"blur(10px)",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,zIndex:250}}>
      <div style={{background:C.card,borderRadius:24,padding:"28px 24px 32px",width:"90%",maxWidth:420,border:`1px solid ${C.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
          <span style={{color:C.accent,fontWeight:800,fontSize:12,letterSpacing:3}}>SÉRIE {setIdx+1}</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,fontSize:28,cursor:"pointer",lineHeight:1}}>×</button>
        </div>
        <p style={{color:C.text,fontWeight:800,fontSize:17,margin:"0 0 6px"}}>{exercise.name}</p>
        <p style={{color:C.muted,fontSize:12,margin:"0 0 24px"}}>Tapez le chiffre pour saisir directement</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24,marginBottom:22}}>
          <NumField label="RÉPÉTITIONS" val={reps} setVal={setReps} step={1} min={1} dec={0} editing={editR} setEditing={setEditR} raw={rawR} setRaw={setRawR} onCommit={commitR} C={C}/>
          <NumField label="POIDS (kg)" val={weight} setVal={setWeight} step={2.5} min={0} dec={1} editing={editW} setEditing={setEditW} raw={rawW} setRaw={setRawW} onCommit={commitW} C={C}/>
        </div>
        {prevSet&&<p style={{color:C.muted,fontSize:13,textAlign:"center",marginBottom:16}}>Dernière fois : <b style={{color:C.text}}>{prevSet.reps} reps × {prevSet.weight} kg</b></p>}
        {suggestion&&(
          <div style={{background:`${C.accent}18`,border:`1px solid ${C.accent}44`,borderRadius:12,padding:"10px 14px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
            
            <div style={{flex:1}}>
              <p style={{color:C.accent,fontWeight:800,fontSize:12,margin:"0 0 2px",letterSpacing:1}}>PROGRESSION SUGGÉRÉE</p>
              <p style={{color:C.text,fontSize:13,margin:0}}>Essaie <b>{suggestion.reps} reps × {suggestion.weight} kg</b></p>
            </div>
            <button onClick={()=>{setReps(suggestion.reps);setWeight(suggestion.weight);setRawR(String(suggestion.reps));setRawW(String(suggestion.weight));}} style={{background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:9,padding:"6px 12px",color:"white",fontWeight:800,fontSize:12,cursor:"pointer"}}>Appliquer</button>
          </div>
        )}
        <BtnC full onClick={()=>onConfirm(reps,weight)}>VALIDER LA SÉRIE</BtnC>
      </div>
    </div>
  );
}

function AddCustomExModal({onAdd,onClose,isTabata,C}) {
  const [name,setName]=useState("");
  const [muscle,setMuscle]=useState(isTabata?"Cardio / Full body":"Pectoraux");
  const muscles=isTabata?[...new Set(TABATA_EX_BASE.map(e=>e.muscle))]:ALL_MUSCLES;
  return (
    <div style={{position:"fixed",inset:0,overscrollBehavior:"none",background:"rgba(0,0,0,0.92)",backdropFilter:"blur(10px)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:350}}>
      <div style={{background:C.card,borderRadius:"24px 24px 0 0",padding:"28px 24px 50px",width:"100%",maxWidth:480,border:`1px solid ${C.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <h3 style={{color:C.text,fontWeight:900,fontSize:17,margin:0}}>NOUVEL EXERCICE</h3>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,fontSize:28,cursor:"pointer",lineHeight:1}}>×</button>
        </div>
        <label style={{color:C.muted,fontSize:11,letterSpacing:2,display:"block",marginBottom:8}}>NOM</label>
        <input value={name} onChange={e=>setName(e.target.value)} placeholder="ex: Curl à la machine..." autoFocus
          style={{width:"100%",background:C.surface,border:`1px solid ${C.accent}`,borderRadius:12,color:C.text,fontSize:16,padding:"12px 14px",outline:"none",boxSizing:"border-box",marginBottom:18}}/>
        <label style={{color:C.muted,fontSize:11,letterSpacing:2,display:"block",marginBottom:10}}>GROUPE MUSCULAIRE</label>
        <div style={{display:"flex",flexWrap:"wrap",gap:7,marginBottom:24}}>
          {muscles.map(m=>{const meta=MM[m]||{};return(
            <button key={m} onClick={()=>setMuscle(m)} style={{padding:"7px 13px",borderRadius:20,border:`1px solid ${muscle===m?(meta.color||C.accent):C.border}`,background:muscle===m?(meta.bg||`${C.accent}18`):"transparent",color:muscle===m?(meta.color||C.accent):C.muted,fontWeight:700,fontSize:12,cursor:"pointer"}}>{m}</button>
          );})}
        </div>
        <button onClick={()=>{if(name.trim())onAdd({id:Date.now(),name:name.trim(),muscle,custom:true});}} disabled={!name.trim()}
          style={{width:"100%",padding:"14px",background:name.trim()?`linear-gradient(135deg,${C.accent},${C.accent2})`:C.faint,border:"none",borderRadius:12,color:name.trim()?"white":C.muted,fontWeight:800,fontSize:15,cursor:name.trim()?"pointer":"default"}}>
          AJOUTER L'EXERCICE
        </button>
      </div>
    </div>
  );
}

function ExPicker({onPick,onClose,C,muscles=null,isTabata=false}) {
  const [filter,setFilter]=useState("Tous");
  const [search,setSearch]=useState("");
  const [showCustom,setShowCustom]=useState(false);
  const pool=isTabata?TABATA_EX_BASE:(muscles?EX.filter(e=>muscles.includes(e.muscle)):EX);
  const muscleList=isTabata?[...new Set(TABATA_EX_BASE.map(e=>e.muscle))]:(muscles||ALL_MUSCLES);
  const filtered=pool.filter(ex=>(filter==="Tous"||ex.muscle===filter)&&ex.name.toLowerCase().includes(search.toLowerCase()));
  return (
    <div style={{position:"fixed",inset:0,overscrollBehavior:"none",background:C.isDark?"rgba(0,0,0,0.97)":"rgba(245,245,240,0.98)",zIndex:280,display:"flex",flexDirection:"column"}}>
      {showCustom&&<AddCustomExModal onAdd={ex=>{onPick(ex);setShowCustom(false);}} onClose={()=>setShowCustom(false)} isTabata={isTabata} C={C}/>}
      <div style={{padding:"calc(env(safe-area-inset-top) + 20px) 20px 12px",display:"flex",alignItems:"center",gap:12}}>
        <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,fontSize:24,cursor:"pointer"}}>←</button>
        <h2 style={{color:C.text,fontSize:18,fontWeight:900,margin:0}}>AJOUTER UN EXERCICE</h2>
      </div>
      <div style={{padding:"0 20px 10px"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Rechercher..."
          style={{width:"100%",background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,color:C.text,fontSize:16,padding:"10px 13px",outline:"none",boxSizing:"border-box"}}/>
      </div>
      <div style={{display:"flex",gap:8,padding:"0 20px 10px",overflowX:"auto"}}>
        {["Tous",...muscleList].map(m=><button key={m} onClick={()=>setFilter(m)} style={{flexShrink:0,padding:"6px 13px",borderRadius:20,border:"none",cursor:"pointer",fontWeight:700,fontSize:12,background:filter===m?C.accent:C.faint,color:filter===m?"white":C.muted}}>{m}</button>)}
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"0 20px 20px"}}>
        <div onClick={()=>setShowCustom(true)} style={{background:`${C.accent}10`,border:`1px dashed ${C.accent}`,borderRadius:12,padding:"13px 14px",marginBottom:10,cursor:"pointer",display:"flex",alignItems:"center",gap:12}}>
          <div style={{width:32,height:32,borderRadius:"50%",background:`${C.accent}20`,display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,flexShrink:0}}><span style={{color:C.accent,fontSize:20,fontWeight:900}}>+</span></div>
          <div><p style={{color:C.accent,fontWeight:800,margin:"0 0 2px",fontSize:14}}>Ajouter un exercice personnalisé</p><p style={{color:C.muted,fontSize:11,margin:0}}>Créez votre propre exercice</p></div>
        </div>
        {filtered.map(ex=>{const meta=MM[ex.muscle]||{};return(
          <div key={ex.id} onClick={()=>onPick(ex)} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:"12px 14px",marginBottom:8,cursor:"pointer",display:"flex",alignItems:"center",gap:12}}>
            <div style={{flex:1}}>
              <p style={{color:C.text,fontWeight:700,margin:"0 0 4px",fontSize:14}}>{ex.name}</p>
              <Tag label={ex.muscle} color={meta.color||C.muted} bg={meta.bg||C.faint}/>
              {!isTabata&&ex.detail&&<p style={{color:C.muted,fontSize:11,fontStyle:"italic",margin:"4px 0 0"}}>{ex.detail}</p>}
            </div>
            <span style={{color:C.accent,fontSize:22,fontWeight:900,flexShrink:0}}>+</span>
          </div>
        );})}
        {filtered.length===0&&<p style={{color:C.muted,textAlign:"center",padding:"32px 0"}}>Aucun exercice trouvé</p>}
      </div>
    </div>
  );
}

// ─── SESSION MUSCU ─────────────────────────────────────────────────────────────
function SessionPage({program:initProg,globalRestTime,voiceEnabled,onFinish,prevSessions,prs,exerciseWeights,C}) {
  const BtnC=mkBtn(C);

  // Injecter les poids de la dernière séance dans les plannedSets du programme
  const injectSavedWeights=(exercises,_savedWeights)=>{
    // On ignore exerciseWeights (record global) — on se base uniquement sur la dernière séance
    return exercises.map(ex=>{
      const sets=ex.plannedSets||[];
      if(!sets.length)return ex;
      // Si les plannedSets ont été définis par l'IA (flag aiSuggested), ne pas écraser
      if(sets[0]?.aiSuggested)return ex;
      // Chercher le poids de la dernière séance pour cet exercice (série 0)
      if(!prevSessions||prevSessions.length===0)return ex;
      let lastWeight=0;
      for(let i=prevSessions.length-1;i>=0;i--){
        const matchEx=prevSessions[i].exercises?.find(e=>e.name===ex.name);
        const set=matchEx?.sets?.[0];
        if(set&&set.weight>0){lastWeight=set.weight;break;}
      }
      if(lastWeight<=0)return ex;
      // Appliquer le poids de la dernière séance sur tous les sets (même valeur)
      return {...ex,plannedSets:sets.map(s=>({...s,weight:lastWeight}))};
    });
  };

  // Restaurer depuis localStorage si même programme ET mêmes exercices
  const _saved=(()=>{try{const r=localStorage.getItem(LS_SESSION_KEY);if(!r)return null;const d=JSON.parse(r);if(d.programId!==initProg.id)return null;const savedNames=(d.exList||[]).map(e=>e.name).join(",");const progNames=initProg.exercises.map(e=>e.name).join(",");if(savedNames!==progNames)return null;return d;}catch{return null;}})();

  const [exList,setExList]=useState(_saved?.exList||injectSavedWeights(initProg.exercises.map(e=>({...e})),exerciseWeights));
  const [exIdx,setExIdx]=useState(_saved?.exIdx||0);
  const [done,setDone]=useState(_saved?.done||{});
  const [showModal,setShowModal]=useState(false);
  const [editIdx,setEditIdx]=useState(null); // entier : édition série via SetModal pendant séance
  const [recapEditIdx,setRecapEditIdx]=useState(null); // objet {ei,si,reps,weight} : édition dans récap final
  const [liveEditIdx,setLiveEditIdx]=useState(null);
  const addTimeRef=useRef(null); // callback pour ajouter du temps au chrono actif
  const serieCardRef=useRef(null); // mesure hauteur carte série
  const [serieCardHeight,setSerieCardHeight]=useState(null);
  useEffect(()=>{
    if(!serieCardRef.current)return;
    const obs=new ResizeObserver(entries=>{
      for(const e of entries) setSerieCardHeight(e.contentRect.height+40); // +padding
    });
    obs.observe(serieCardRef.current);
    return()=>obs.disconnect();
  },[]);
  const [showTimer,setShowTimer]=useState(false);
  const [showPicker,setShowPicker]=useState(false);
  const [showEdit,setShowEdit]=useState(false);
  const dragState=useRef({dragging:false,fromIdx:null,toIdx:null,startY:0,itemHeight:0});
  const dragItemRefs=useRef([]);
  const [dragFrom,setDragFrom]=useState(null);
  const [dragOver,setDragOver]=useState(null);
  const startDrag=(i,clientY)=>{
    const el=dragItemRefs.current[i];
    if(el)dragState.current.itemHeight=el.getBoundingClientRect().height+8;
    dragState.current={dragging:true,fromIdx:i,toIdx:i,startY:clientY,itemHeight:dragState.current.itemHeight};
    setDragFrom(i);setDragOver(i);
  };
  const moveDrag=(clientY)=>{
    if(!dragState.current.dragging)return;
    const diff=clientY-dragState.current.startY;
    const h=dragState.current.itemHeight||60;
    const steps=Math.round(diff/h);
    const newIdx=Math.max(0,Math.min(exList.length-1,dragState.current.fromIdx+steps));
    dragState.current.toIdx=newIdx;
    setDragOver(newIdx);
  };
  const endDrag=()=>{
    if(!dragState.current.dragging)return;
    const{fromIdx,toIdx}=dragState.current;
    dragState.current.dragging=false;
    setDragFrom(null);setDragOver(null);
    if(fromIdx===toIdx)return;
    setExList(p=>{
      const arr=[...p];
      const[item]=arr.splice(fromIdx,1);
      arr.splice(toIdx,0,item);
      return arr;
    });
    setExIdx(prev=>{
      if(prev===fromIdx)return toIdx;
      if(fromIdx<toIdx&&prev>fromIdx&&prev<=toIdx)return prev-1;
      if(fromIdx>toIdx&&prev<fromIdx&&prev>=toIdx)return prev+1;
      return prev;
    });
  };
  const [newPR,setNewPR]=useState(null);
  const [showGuide,setShowGuide]=useState(false);
  const [showFinishConfirm,setShowFinishConfirm]=useState(false);
  const [curReps,setCurReps]=useState(null);
  const [curWeight,setCurWeight]=useState(null);
  const [startTime]=useState(_saved?.startTime||Date.now());
  const [elapsed,setElapsed]=useState(0);
  const wakeLockRef=useRef(null);

  // Persister la session à chaque changement
  useEffect(()=>{
    try{localStorage.setItem(LS_SESSION_KEY,JSON.stringify({programId:initProg.id,exList,exIdx,done,startTime}));}catch{}
  },[exList,exIdx,done]);

  useEffect(()=>{
    const id=setInterval(()=>setElapsed(Math.floor((Date.now()-startTime)/1000)),1000);
    const acquireWL=async()=>{try{if("wakeLock" in navigator){wakeLockRef.current=await navigator.wakeLock.request("screen");}}catch(e){}};
    acquireWL();
    const onVis=()=>{if(document.visibilityState==="visible")acquireWL();};
    document.addEventListener("visibilitychange",onVis);
    return()=>{clearInterval(id);document.removeEventListener("visibilitychange",onVis);wakeLockRef.current?.release();wakeLockRef.current=null;};
  },[]);
  const ex=exList[exIdx];
  const doneSets=done[ex.name]||[];
  const planned=ex?.plannedSets?.length||0;
  // Reset valeurs inline à chaque changement d'exercice
  useEffect(()=>{setCurReps(null);setCurWeight(null);},[exIdx]);
  const exRest=ex?.restTime??globalRestTime??90;
  // Retourne le set du DERNIER enregistrement validé sur les sessions précédentes (recherche par nom)
  const getPrev=(ei,si)=>{
    if(!prevSessions||prevSessions.length===0)return null;
    const exName=exList[ei]?.name;
    if(!exName)return null;
    // Parcourir du plus récent au plus ancien
    for(let i=prevSessions.length-1;i>=0;i--){
      const matchEx=prevSessions[i].exercises?.find(e=>e.name===exName);
      const set=matchEx?.sets?.[si];
      if(set&&(set.weight>0||set.reps>0))return set;
    }
    return null;
  };
  const getSugR=(ei,si)=>{
    // Priorité IA si suggestions appliquées
    const planned=exList[ei]?.plannedSets?.[si];
    if(planned?.aiSuggested) return planned.reps??10;
    // Sinon : séance précédente → plannedSets → défaut
    return getPrev(ei,si)?.reps??planned?.reps??10;
  };
  const getSugW=(ei,si)=>{
    // Priorité IA si suggestions appliquées
    const planned=exList[ei]?.plannedSets?.[si];
    if(planned?.aiSuggested) return planned.weight??0;
    // Sinon : dernière séance → plannedSets (pas de exerciseWeights/record global)
    const prev=getPrev(ei,si);
    if(prev&&prev.weight>0)return prev.weight;
    return planned?.weight??0;
  };

  // Suggestion de progression : déclenche si ≥3 séances au même poids avec reps cibles atteintes
  const getProgression=(ei,si)=>{
    if(!prevSessions||prevSessions.length<3)return null;
    const targetReps=exList[ei]?.plannedSets?.[si]?.reps??10;
    const exName=exList[ei]?.name;
    const lastSessions=prevSessions.slice(-3);
    const sets=lastSessions.map(s=>{
      const matchEx=s.exercises?.find(e=>e.name===exName);
      return matchEx?.sets?.[si];
    }).filter(Boolean);
    if(sets.length<3)return null;
    const refWeight=sets[0].weight;
    // Toutes les séances : même poids ET reps >= cibles
    const consistent=sets.every(s=>s.weight===refWeight&&s.reps>=targetReps);
    if(!consistent||refWeight<=0)return null;
    return{reps:targetReps,weight:parseFloat((refWeight+2.5).toFixed(1))};
  };
  const handleConfirmInline=(reps,weight)=>{
    // Feedback haptique : double impulsion courte
    if(navigator?.vibrate){try{navigator.vibrate([40,60,40]);}catch{}}
    setDone(prev=>{const nx={...prev},arr=[...(nx[ex.name]||[])];arr.push({reps,weight});nx[ex.name]=arr;return nx;});
    // Si nouveau poids max sur cet exercice → mettre à jour plannedSets en temps réel
    if(weight>0){
      setExList(prev=>{
        const ex2=prev[exIdx];
        if(!ex2?.plannedSets?.length)return prev;
        const sets=ex2.plannedSets;
        const origMax=Math.max(...sets.map(s=>s.weight||0));
        const currentDoneCount=(done[ex.name]||[]).length; // nb séries déjà validées avant celle-ci
        if(origMax<=0||weight<=origMax)return prev; // pas de nouveau max → pas de mise à jour
        // Nouveau max → recalculer les séries restantes (non encore validées)
        const newSets=sets.map((s,si)=>{
          if(si<=currentDoneCount)return s; // série déjà validée ou en cours → ne pas toucher
          const ratio=origMax>0?(s.weight||0)/origMax:1;
          const newW=Math.round(weight*ratio/2.5)*2.5;
          return {...s,weight:newW};
        });
        return prev.map((e,i)=>i===exIdx?{...e,plannedSets:newSets}:e);
      });
    }
    setCurReps(null);setCurWeight(null);
    if(weight>0&&reps===1){const exName=ex?.name;const currentPR=prs?.[exName]?.weight||0;if(weight>currentPR){setNewPR({name:exName,weight});setTimeout(()=>setNewPR(null),3500);}}
    if(voiceEnabled)speak(`Série validée. ${reps} reps, ${weight} kilos.`);
    
    // Skip timer si dernière série du dernier exercice
    const isLastExercise = exIdx === exList.length - 1;
    const currentSetCount = (done[ex.name]||[]).length + 1;
    const plannedSets = exList[exIdx]?.plannedSets?.length || 0;
    const isLastSet = currentSetCount >= plannedSets;

    if(isLastExercise && isLastSet){
      setShowTimer(false);
    } else {
      setShowTimer(true);
    }
  };
  const handleConfirm=(reps,weight)=>{
    const isEdit=editIdx!==null;
    if(navigator?.vibrate){try{navigator.vibrate([40,60,40]);}catch{}}
    setDone(prev=>{const nx={...prev},arr=[...(nx[ex.name]||[])];if(isEdit)arr[editIdx]={reps,weight};nx[ex.name]=arr;return nx;});
    setShowModal(false);setEditIdx(null);
  };
  const handleTimerDone=()=>{
    setShowTimer(false);
    const cnt=(done[ex.name]||[]).length;
    const pl=exList[exIdx]?.plannedSets?.length||0;
    if(cnt>=pl&&exIdx<exList.length-1){
      const ni=exIdx+1;
      setExIdx(ni);
      setCurReps(null);setCurWeight(null);
      if(voiceEnabled)speak(`Prochain : ${exList[ni].name}`);
    }
  };
  const handleFinish=()=>{
    try{localStorage.removeItem(LS_SESSION_KEY);}catch{}
    if(navigator?.vibrate){try{navigator.vibrate([60,80,60,80,120]);}catch{}}
    onFinish({id:Date.now(),type:"muscu",programId:initProg.id,programName:initProg.name,date:(()=>{const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}T${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}:00`;})(),duration:Math.floor((Date.now()-startTime)/60000),exercises:exList.map((e,i)=>({name:e.name,muscle:e.muscle,detail:e.detail,sets:done[e.name]||[]}))});
  };
  const handleDiscard=()=>{
    try{localStorage.removeItem(LS_SESSION_KEY);}catch{}
    onFinish(null);
  };
  const addEx=ex=>{setExList(p=>[...p,{...ex,restTime:90,plannedSets:[{reps:10,weight:0},{reps:10,weight:0},{reps:10,weight:0}]}]);setShowPicker(false);};
  const removeEx=i=>{if(exList.length<=1)return;const removedName=exList[i].name;setExList(p=>p.filter((_,j)=>j!==i));setDone(prev=>{const nx={...prev};delete nx[removedName];return nx;});if(exIdx>=i&&exIdx>0)setExIdx(p=>p-1);};
  const totalDone=Object.values(done).reduce((a,b)=>a+b.length,0);
  const totalReq=exList.reduce((a,e)=>a+(e.plannedSets?.length||0),0);
  const progress=totalReq>0?totalDone/totalReq:0;
  const meta=MM[ex?.muscle]||{};
  if(!ex)return null;
  return (
    <div style={{position:"fixed",inset:0,overscrollBehavior:"none",background:C.bg,display:"flex",flexDirection:"column",overflow:"hidden"}}>
      {showGuide&&<MovementGuide exercise={ex} onClose={()=>setShowGuide(false)} C={C}/>}

      {/* Modal confirmation fin de séance */}
      {showFinishConfirm&&(
        <div style={{position:"fixed",inset:0,overscrollBehavior:"none",background:"rgba(0,0,0,0.7)",backdropFilter:"blur(8px)",zIndex:400,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div style={{background:C.card,borderRadius:"24px 24px 0 0",padding:"28px 24px 50px",width:"100%",maxWidth:480,border:`1px solid ${C.border}`}}>
            <p style={{color:C.text,fontWeight:900,fontSize:17,margin:"0 0 6px",textAlign:"center"}}>Terminer la séance ?</p>
            <p style={{color:C.muted,fontSize:13,margin:"0 0 28px",textAlign:"center",lineHeight:1.5}}>
              {totalDone} série{totalDone>1?"s":""} effectuée{totalDone>1?"s":""} · {Math.floor((Date.now()-startTime)/60000)} min
            </p>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <button onClick={handleFinish}
                style={{width:"100%",padding:"15px",background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:14,color:"white",fontWeight:900,fontSize:16,cursor:"pointer",boxShadow:`0 4px 16px ${C.glow}`}}>
                Enregistrer la séance
              </button>
              <button onClick={handleDiscard}
                style={{width:"100%",padding:"15px",background:"rgba(239,68,68,0.08)",border:"1px solid rgba(239,68,68,0.25)",borderRadius:14,color:C.red,fontWeight:700,fontSize:15,cursor:"pointer"}}>
                Supprimer sans enregistrer
              </button>
              <button onClick={()=>setShowFinishConfirm(false)}
                style={{width:"100%",padding:"12px",background:"none",border:"none",color:C.muted,fontWeight:700,fontSize:14,cursor:"pointer"}}>
                Continuer la séance
              </button>
            </div>
          </div>
        </div>
      )}
      {newPR&&(
        <div style={{position:"fixed",top:20,left:"50%",transform:"translateX(-50%)",zIndex:400,background:`linear-gradient(135deg,${C.accent},${C.accent2})`,borderRadius:16,padding:"12px 20px",boxShadow:`0 8px 28px ${C.glow}`,display:"flex",alignItems:"center",gap:10,maxWidth:300,animation:"slideDown 0.3s ease"}}>
          
          <div>
            <p style={{color:"white",fontWeight:900,fontSize:13,margin:"0 0 1px"}}>CRÉER PR !</p>
            <p style={{color:"rgba(255,255,255,0.85)",fontSize:12,margin:0}}>{newPR.name} · {newPR.weight} kg</p>
          </div>
        </div>
      )}
      {showModal&&<SetModal setIdx={editIdx!==null?editIdx:doneSets.length} exercise={ex} defaultReps={getSugR(exIdx,editIdx!==null?editIdx:doneSets.length)} defaultWeight={getSugW(exIdx,editIdx!==null?editIdx:doneSets.length)} prevSet={editIdx!==null?doneSets[editIdx]:getPrev(exIdx,doneSets.length)} suggestion={editIdx===null?getProgression(exIdx,doneSets.length):null} onConfirm={handleConfirm} onClose={()=>{setShowModal(false);setEditIdx(null);}} C={C}/>}
      

      {/* Header session principal */}
      <div style={{padding:"calc(env(safe-area-inset-top) + 14px) 16px 8px",background:C.surface,borderBottom:`1px solid ${C.border}`,flexShrink:0}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3}}>
              <h2 style={{color:C.text,fontSize:17,fontWeight:900,margin:0}}>{initProg.name}</h2>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:5}}>
              <span style={{color:C.accent,fontSize:10,letterSpacing:2}}>EN COURS</span>
              <div style={{background:`${C.accent}20`,border:`1px solid ${C.accent}40`,borderRadius:20,padding:"2px 9px",display:"flex",alignItems:"center",gap:4}}>
                
                <span style={{color:C.accent,fontSize:13,fontWeight:900,fontVariantNumeric:"tabular-nums"}}>{fmt(elapsed)}</span>
              </div>
            </div>
          </div>
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>setShowEdit(true)} style={{padding:"6px 10px",background:C.faint,border:`1px solid ${C.border}`,borderRadius:10,color:C.muted,fontSize:11,fontWeight:700,cursor:"pointer",textAlign:"center",lineHeight:1.3}}>Modifier<br/>séance</button>
            <button onClick={()=>setShowFinishConfirm(true)} style={{padding:"6px 10px",background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.35)",borderRadius:10,color:C.red,fontSize:11,fontWeight:700,cursor:"pointer",textAlign:"center",lineHeight:1.3}}>Terminer<br/>séance</button>
          </div>
        </div>
        <div style={{background:C.faint,borderRadius:999,height:5,marginBottom:4}}><div style={{height:"100%",width:`${progress*100}%`,background:`linear-gradient(90deg,${C.accent},${C.accent2})`,borderRadius:999,transition:"width 0.5s"}}/></div>
        <p style={{color:C.muted,fontSize:10,margin:0,textAlign:"right"}}>{totalDone}/{totalReq} séries</p>
      </div>
      {showEdit&&(
        <div style={{position:"fixed",inset:0,overscrollBehavior:"none",background:C.bg,zIndex:300,display:"flex",flexDirection:"column",overflowY:"auto"}}>
          {showPicker&&<ExPicker onPick={addEx} onClose={()=>setShowPicker(false)} C={C}/>}
          {/* Header */}
          <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:"calc(env(safe-area-inset-top) + 20px) 20px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
            <div>
              <p style={{color:C.accent,fontSize:10,letterSpacing:3,margin:"0 0 4px",fontWeight:700}}>SÉANCE EN COURS</p>
              <h2 style={{color:C.text,fontSize:19,fontWeight:900,margin:0}}>{initProg.name}</h2>
            </div>
            <button onClick={()=>setShowEdit(false)} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:"50%",width:40,height:40,color:C.text,fontSize:22,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,flexShrink:0}}>×</button>
          </div>

          {/* Contenu */}
          <div style={{padding:"20px 20px 60px",flex:1}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <p style={{color:C.muted,fontSize:11,letterSpacing:2,margin:0,fontWeight:700}}>EXERCICES</p>
              <button onClick={()=>setShowPicker(true)} style={{background:`${C.accent}18`,border:`1px solid ${C.accent}40`,borderRadius:10,padding:"8px 14px",color:C.accent,fontSize:13,fontWeight:800,cursor:"pointer"}}>+ Ajouter un exercice</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}
              onMouseMove={ev=>moveDrag(ev.clientY)}
              onMouseUp={endDrag}
              onMouseLeave={endDrag}
              onTouchMove={ev=>{ev.preventDefault();moveDrag(ev.touches[0].clientY);}}
              onTouchEnd={endDrag}
            >
              {exList.map((e,i)=>(
                <div key={e.name} ref={el=>dragItemRefs.current[i]=el}
                  style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",
                    background:i===exIdx?`${C.accent}12`:C.card,
                    border:`1px solid ${i===exIdx?C.accent:dragOver===i&&dragFrom!==null&&dragFrom!==i?C.accent:C.border}`,
                    borderRadius:14,
                    opacity:dragFrom===i?0.45:1,
                    transition:"opacity 0.15s,border-color 0.15s",
                    transform:dragOver===i&&dragFrom!==null&&dragFrom!==i?"scale(1.01)":"scale(1)"}}>
                  {/* Poignée drag */}
                  <div
                    onMouseDown={ev=>{ev.preventDefault();startDrag(i,ev.clientY);}}
                    onTouchStart={ev=>{startDrag(i,ev.touches[0].clientY);}}
                    style={{flexShrink:0,cursor:"grab",padding:"4px 6px",display:"flex",alignItems:"center",justifyContent:"center",touchAction:"none"}}>
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none">
                      {[1,6,11].map(y=>(
                        <line key={y} x1="2" y1={y+1} x2="14" y2={y+1} stroke={C.muted} strokeWidth="1.8" strokeLinecap="round" opacity="0.6"/>
                      ))}
                    </svg>
                  </div>
                  {/* Infos exercice */}
                  <div style={{flex:1,minWidth:0}}>
                    <p style={{color:i===exIdx?C.accent:C.text,fontWeight:700,fontSize:14,margin:"0 0 2px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</p>
                    <p style={{color:C.muted,fontSize:12,margin:0}}>{(done[e.name]||[]).length}/{e.plannedSets.length} séries faites{i===exIdx?" · En cours":""}</p>
                  </div>
                  {/* Supprimer */}
                  {exList.length>1&&(
                    <button onClick={()=>{removeEx(i);}} style={{background:"rgba(239,68,68,0.08)",border:"1px solid rgba(239,68,68,0.2)",borderRadius:8,padding:"6px 10px",color:C.red,fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0}}>Retirer</button>
                  )}
                </div>
              ))}
            </div>

            {/* Bouton retour */}
            <button onClick={()=>setShowEdit(false)} style={{marginTop:24,width:"100%",padding:"14px",background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:14,color:"white",fontWeight:900,fontSize:16,cursor:"pointer",boxShadow:`0 4px 16px ${C.glow}`}}>
              Reprendre la séance
            </button>
          </div>
        </div>
      )}
      <div style={{flex:1,overflowY:"auto",padding:"16px 18px 80px"}}>

        {/* Header : nom programme + muscles + bouton guide */}
        <div style={{marginBottom:14}}>
          <div style={{marginBottom:6}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:2}}>
              <p style={{color:C.accent,fontSize:10,letterSpacing:2,margin:0,fontWeight:700}}>{initProg.name}</p>
              <div style={{display:"flex",gap:4,alignItems:"center"}}>
                <button onClick={()=>setExIdx(p=>Math.max(0,p-1))} disabled={exIdx===0}
                  style={{width:28,height:28,borderRadius:"50%",background:C.faint,border:`1px solid ${C.border}`,color:exIdx===0?C.border:C.muted,fontSize:15,cursor:exIdx===0?"default":"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>‹</button>
                <span style={{color:C.muted,fontSize:10,fontWeight:700}}>{exIdx+1}/{exList.length}</span>
                <button onClick={()=>{if(exIdx<exList.length-1)setExIdx(p=>p+1);else setShowFinishConfirm(true);}}
                  style={{width:28,height:28,borderRadius:"50%",background:C.faint,border:`1px solid ${C.border}`,color:C.muted,fontSize:15,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>›</button>
              </div>
            </div>
            <h3 style={{color:C.text,fontSize:19,fontWeight:900,margin:"0 0 6px",lineHeight:1.2,wordBreak:"break-word"}}>{ex.name}</h3>
            <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
              <Tag label={ex.muscle} color={MM[ex.muscle]?.color||C.muted} bg={MM[ex.muscle]?.bg||C.faint}/>
              {ex.detail&&<span style={{color:C.muted,fontSize:11}}>• {ex.detail}</span>}
            </div>
          </div>
          <button onClick={()=>setShowGuide(true)}
            style={{width:"100%",padding:"9px 14px",background:`${C.accent}12`,border:`1px solid ${C.accent}40`,borderRadius:11,color:C.accent,fontSize:13,fontWeight:800,cursor:"pointer",textAlign:"left"}}>
            Comment réaliser cet exercice ?
          </button>
        </div>

        {/* Barre progression séries + modifier nb séries */}
        <div style={{marginBottom:18}}>
          <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:6}}>
            {Array.from({length:planned}).map((_,i)=>(
              <div key={i} style={{flex:1,height:6,borderRadius:4,background:doneSets[i]?C.accent:i===doneSets.length?`${C.accent}45`:C.faint,transition:"background 0.3s"}}/>
            ))}
            <span style={{color:C.accent,fontWeight:900,fontSize:13,marginLeft:5,whiteSpace:"nowrap"}}>{doneSets.length}/{planned}</span>
          </div>
          <div style={{display:"flex",alignItems:"center",justifyContent:"flex-end",gap:8}}>
            <span style={{color:C.muted,fontSize:11,fontWeight:600}}>Séries</span>
            <button
              disabled={planned<=1||doneSets.length>=planned}
              onClick={()=>setExList(p=>p.map((e,i)=>i===exIdx&&e.plannedSets.length>1?{...e,plannedSets:e.plannedSets.slice(0,-1)}:e))}
              style={{width:26,height:26,borderRadius:"50%",background:C.faint,border:`1px solid ${C.border}`,color:(planned<=1||doneSets.length>=planned)?C.border:C.muted,fontSize:16,cursor:(planned<=1||doneSets.length>=planned)?"default":"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>−</button>
            <span style={{color:C.text,fontSize:13,fontWeight:800,minWidth:14,textAlign:"center"}}>{planned}</span>
            <button
              onClick={()=>setExList(p=>p.map((e,i)=>i===exIdx?{...e,plannedSets:[...e.plannedSets,{reps:e.plannedSets.at(-1)?.reps??10,weight:e.plannedSets.at(-1)?.weight??0}]}:e))}
              style={{width:26,height:26,borderRadius:"50%",background:C.faint,border:`1px solid ${C.border}`,color:C.accent,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>+</button>
          </div>
        </div>

        {/* ZONE CENTRALE — flux : saisie → repos → saisie → ... → repos final → récap */}
        {(()=>{
          // Repos actif : s'affiche quel que soit doneSets.length
          if(showTimer){
            const allDone=doneSets.length>=planned;
            return(
              <RestTimer
                  duration={exRest}
                  onDone={handleTimerDone}
                  voiceEnabled={voiceEnabled}
                  remainingSets={allDone?[]:ex.plannedSets.slice(doneSets.length)}
                  exerciseName={ex.name}
                  nextExercise={allDone&&exIdx<exList.length-1?exList[exIdx+1]:null}
                  onAddTime={addTimeRef}
                  exRest={exRest}
                  onAdjustRest={(delta)=>{setExList(p=>p.map((e,i)=>i===exIdx?{...e,restTime:delta<0?Math.max(15,(e.restTime??globalRestTime??90)+delta):Math.min(600,(e.restTime??globalRestTime??90)+delta)}:e));if(addTimeRef.current)addTimeRef.current(delta);}}
                  cardHeight={serieCardHeight}
                  C={C}
              />
            );
          }

          // Récap dernier exercice avant validation séance
          if(doneSets.length>=planned&&exIdx===exList.length-1){
            // État d'édition inline dans le récap: {ei, si}
            return(
              <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:20,padding:"18px",marginBottom:14}}>
                <p style={{color:C.accent,fontSize:10,letterSpacing:3,margin:"0 0 14px",fontWeight:700}}>RÉCAP DE LA SÉANCE</p>
                <p style={{color:C.muted,fontSize:11,margin:"-8px 0 14px",textAlign:"center"}}>Appuie sur une série pour corriger</p>
                {exList.map((e,ei)=>{
                  const sets=done[e.name]||[];
                  if(!sets.length) return null;
                  return(
                    <div key={ei} style={{marginBottom:14}}>
                      <p style={{color:C.text,fontWeight:800,fontSize:13,margin:"0 0 6px"}}>{e.name}</p>
                      <div style={{display:"flex",flexDirection:"column",gap:4}}>
                        {sets.map((s,si)=>{
                          const isEditing=recapEditIdx&&recapEditIdx.ei===ei&&recapEditIdx.si===si;
                          if(isEditing){
                            const eReps=recapEditIdx.reps;
                            const eWeight=recapEditIdx.weight;
                            return(
                              <div key={si} style={{background:`${C.accent}12`,border:`1px solid ${C.accent}40`,borderRadius:10,padding:"10px 12px"}}>
                                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                                  <span style={{color:C.muted,fontSize:11,fontWeight:700,minWidth:16}}>{si+1}.</span>
                                  {/* Reps */}
                                  <div style={{display:"flex",alignItems:"center",gap:4,flex:"0 0 auto"}}>
                                    <button onClick={()=>setRecapEditIdx(p=>({...p,reps:Math.max(1,p.reps-1)}))} style={{width:28,height:28,borderRadius:8,background:C.faint,border:`1px solid ${C.border}`,color:C.text,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>−</button>
                                    <input type="text" inputMode="numeric" value={String(eReps)}
                                      onChange={ev=>{const v=parseInt(ev.target.value);if(!isNaN(v)&&v>0)setRecapEditIdx(p=>({...p,reps:v}));}}
                                      onFocus={ev=>ev.target.select()}
                                      style={{width:"2ch",background:"transparent",border:"none",borderBottom:`1px solid ${C.accent}`,color:C.text,fontSize:16,fontWeight:800,textAlign:"center",outline:"none"}}/>
                                    <button onClick={()=>setRecapEditIdx(p=>({...p,reps:p.reps+1}))} style={{width:28,height:28,borderRadius:8,background:C.faint,border:`1px solid ${C.border}`,color:C.accent,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>+</button>
                                    <span style={{color:C.muted,fontSize:11}}>reps</span>
                                  </div>
                                  {/* Weight */}
                                  <div style={{display:"flex",alignItems:"center",gap:4,flex:"1 1 auto",minWidth:0,justifyContent:"flex-end"}}>
                                    <button onClick={()=>setRecapEditIdx(p=>({...p,weight:parseFloat(Math.max(0,p.weight-2.5).toFixed(1))}))} style={{width:28,height:28,borderRadius:8,background:C.faint,border:`1px solid ${C.border}`,color:C.text,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,flexShrink:0}}>−</button>
                                    <input type="text" inputMode="decimal" value={eWeight%1===0?String(eWeight):eWeight.toFixed(1)}
                                      onChange={ev=>{const v=parseFloat(ev.target.value);if(!isNaN(v)&&v>=0)setRecapEditIdx(p=>({...p,weight:v}));}}
                                      onFocus={ev=>ev.target.select()}
                                      style={{width:"6ch",minWidth:0,flexShrink:0,background:"transparent",border:"none",borderBottom:`1px solid ${C.accent}`,color:C.accent,fontSize:16,fontWeight:800,textAlign:"center",outline:"none"}}/>
                                    <button onClick={()=>setRecapEditIdx(p=>({...p,weight:parseFloat((p.weight+2.5).toFixed(1))}))} style={{width:28,height:28,borderRadius:8,background:C.faint,border:`1px solid ${C.border}`,color:C.accent,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,flexShrink:0}}>+</button>
                                    <span style={{color:C.muted,fontSize:11,flexShrink:0}}>kg</span>
                                  </div>
                                </div>
                                <div style={{display:"flex",gap:6}}>
                                  <button onClick={()=>{
                                    setDone(prev=>{const nx={...prev},arr=[...(nx[e.name]||[])];arr[si]={reps:eReps,weight:eWeight};nx[e.name]=arr;return nx;});
                                    setRecapEditIdx(null);
                                  }} style={{flex:1,padding:"7px",background:C.accent,border:"none",borderRadius:8,color:"white",fontWeight:800,fontSize:12,cursor:"pointer"}}>✓ Valider</button>
                                  <button onClick={()=>setRecapEditIdx(null)} style={{padding:"7px 14px",background:C.faint,border:`1px solid ${C.border}`,borderRadius:8,color:C.muted,fontWeight:700,fontSize:12,cursor:"pointer"}}>Annuler</button>
                                </div>
                              </div>
                            );
                          }
                          return(
                            <button key={si} onClick={()=>setRecapEditIdx({ei,si,reps:s.reps,weight:s.weight})}
                              style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",background:C.faint,borderRadius:8,border:`1px solid ${C.border}`,cursor:"pointer",textAlign:"left",width:"100%"}}>
                              <span style={{color:C.muted,fontSize:11,fontWeight:700,minWidth:16}}>{si+1}.</span>
                              <span style={{color:C.text,fontSize:13,flex:1}}>{s.reps} reps</span>
                              {s.weight>0&&<span style={{color:C.accent,fontWeight:800,fontSize:13}}>{s.weight} kg</span>}
                              <span style={{color:C.muted,fontSize:11}}>✎</span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
                <button onClick={()=>setShowFinishConfirm(true)}
                  style={{width:"100%",marginTop:8,padding:"14px",background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:14,color:"white",fontWeight:900,fontSize:16,cursor:"pointer",boxShadow:`0 4px 16px ${C.glow}`}}>
                  Terminer la séance →
                </button>
              </div>
            );
          }

          // Saisie série courante
          if(doneSets.length<planned){
            const si=doneSets.length;
            const prevSet=getPrev(exIdx,si);
            const suggestion=getProgression(exIdx,si);
            const reps=curReps!==null?curReps:getSugR(exIdx,si);
            const weight=curWeight!==null?curWeight:getSugW(exIdx,si);
            const setR=v=>setCurReps(Math.max(1,Math.round(v)));
            const setW=v=>setCurWeight(parseFloat(Math.max(0,v).toFixed(1)));
            const fmtW=v=>v%1===0?String(v):v.toFixed(1);
            return(
              <div ref={serieCardRef} style={{background:`linear-gradient(135deg,${C.accent}12,${C.accent2}07)`,border:`1px solid ${C.accent}30`,borderRadius:22,padding:"20px 18px 18px",marginBottom:14}}>
                <p style={{color:C.accent,fontSize:10,letterSpacing:3,margin:"0 0 18px",fontWeight:700,textAlign:"center"}}>SÉRIE {si+1} SUR {planned}</p>

                {/* REPS */}
                <div style={{marginBottom:16}}>
                  <p style={{color:C.muted,fontSize:10,letterSpacing:2,margin:"0 0 8px",fontWeight:600,textAlign:"center"}}>RÉPÉTITIONS</p>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <button onClick={()=>setR(reps-1)}
                      style={{width:52,height:52,borderRadius:14,background:C.faint,border:`1px solid ${C.border}`,color:C.text,fontSize:28,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,fontWeight:300}}>−</button>
                    <input type="text" inputMode="numeric" value={String(reps)}
                      onChange={e=>{const v=parseInt(e.target.value);if(!isNaN(v)&&v>0)setR(v);}}
                      onFocus={e=>e.target.select()}
                      style={{flex:1,background:"transparent",border:"none",borderBottom:`2px solid ${C.text}40`,color:C.text,fontSize:32,fontWeight:900,textAlign:"center",outline:"none",padding:"2px 0",minWidth:0,boxSizing:"border-box"}}
                    />
                    <button onClick={()=>setR(reps+1)}
                      style={{width:52,height:52,borderRadius:14,background:C.faint,border:`1px solid ${C.border}`,color:C.text,fontSize:28,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,fontWeight:300}}>+</button>
                  </div>
                </div>

                {/* POIDS */}
                <div style={{marginBottom:18}}>
                  <p style={{color:C.muted,fontSize:10,letterSpacing:2,margin:"0 0 8px",fontWeight:600,textAlign:"center"}}>POIDS (kg)</p>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <button onClick={()=>setW(weight-2.5)}
                      style={{width:52,height:52,borderRadius:14,background:C.faint,border:`1px solid ${C.border}`,color:C.text,fontSize:28,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,fontWeight:300}}>−</button>
                    <input type="text" inputMode="decimal" value={fmtW(weight)}
                      onChange={e=>{const raw=e.target.value.replace(',','.');const v=parseFloat(raw);if(!isNaN(v)&&v>=0)setW(v);}}
                      onFocus={e=>e.target.select()}
                      style={{flex:1,background:"transparent",border:"none",borderBottom:`2px solid ${C.accent}50`,color:C.accent,fontSize:32,fontWeight:900,textAlign:"center",outline:"none",padding:"2px 0",minWidth:0,boxSizing:"border-box"}}
                    />
                    <button onClick={()=>setW(weight+2.5)}
                      style={{width:52,height:52,borderRadius:14,background:C.faint,border:`1px solid ${C.border}`,color:C.accent,fontSize:28,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,fontWeight:300}}>+</button>
                  </div>
                </div>

                {prevSet&&<p style={{color:C.muted,fontSize:12,textAlign:"center",margin:"0 0 10px"}}>Dernière fois : <b style={{color:C.text}}>{prevSet.reps} reps × {prevSet.weight} kg</b></p>}
                {suggestion&&(
                  <div style={{background:`${C.accent}15`,border:`1px solid ${C.accent}35`,borderRadius:10,padding:"8px 12px",marginBottom:12,display:"flex",alignItems:"center",gap:10}}>
                    
                    <p style={{color:C.accent,fontWeight:700,fontSize:12,margin:0,flex:1}}>Essaie {suggestion.reps} reps × {suggestion.weight} kg</p>
                    <button onClick={()=>{setCurReps(suggestion.reps);setCurWeight(suggestion.weight);}} style={{background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:8,padding:"5px 10px",color:"white",fontWeight:800,fontSize:11,cursor:"pointer"}}>Appliquer</button>
                  </div>
                )}
                <button onClick={()=>handleConfirmInline(reps,weight)}
                  style={{width:"100%",padding:"15px",background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:14,color:"white",fontWeight:900,fontSize:17,cursor:"pointer",boxShadow:`0 5px 18px ${C.glow}`}}>
                  Valider la série →
                </button>
              </div>
            );
          }

          // Toutes séries faites sur un exercice intermédiaire : repos final avant de passer au suivant
          return null;
        })()}

        {/* Séries passées — masquées dans le récap final */}
        {!showTimer&&doneSets.length>0&&!(doneSets.length>=planned&&exIdx===exList.length-1)&&(
          <div style={{marginBottom:16}}>
            <p style={{color:C.muted,fontSize:10,letterSpacing:2,margin:"0 0 8px",fontWeight:700}}>SÉRIES EFFECTUÉES</p>
            <div style={{display:"flex",flexDirection:"column",gap:5}}>
            {doneSets.map((d,si)=>{
              const isEditing=liveEditIdx&&liveEditIdx.si===si;
              if(isEditing){
                return(
                  <div key={si} style={{background:`${C.accent}12`,border:`1px solid ${C.accent}40`,borderRadius:11,padding:"10px 12px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                      <span style={{color:C.muted,fontSize:11,fontWeight:700,minWidth:16}}>{si+1}.</span>
                      <div style={{display:"flex",alignItems:"center",gap:4,flex:"0 0 auto"}}>
                        <button onClick={()=>setLiveEditIdx(p=>({...p,reps:Math.max(1,p.reps-1)}))} style={{width:28,height:28,borderRadius:8,background:C.faint,border:`1px solid ${C.border}`,color:C.text,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>−</button>
                        <input type="text" inputMode="numeric" value={String(liveEditIdx.reps)}
                          onChange={ev=>{const v=parseInt(ev.target.value);if(!isNaN(v)&&v>0)setLiveEditIdx(p=>({...p,reps:v}));}}
                          onFocus={ev=>ev.target.select()}
                          style={{width:"2ch",background:"transparent",border:"none",borderBottom:`1px solid ${C.accent}`,color:C.text,fontSize:16,fontWeight:800,textAlign:"center",outline:"none"}}/>
                        <button onClick={()=>setLiveEditIdx(p=>({...p,reps:p.reps+1}))} style={{width:28,height:28,borderRadius:8,background:C.faint,border:`1px solid ${C.border}`,color:C.accent,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1}}>+</button>
                        <span style={{color:C.muted,fontSize:11}}>reps</span>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:4,flex:"1 1 auto",minWidth:0,justifyContent:"flex-end"}}>
                        <button onClick={()=>setLiveEditIdx(p=>({...p,weight:parseFloat(Math.max(0,p.weight-2.5).toFixed(1))}))} style={{width:28,height:28,borderRadius:8,background:C.faint,border:`1px solid ${C.border}`,color:C.text,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,flexShrink:0}}>−</button>
                        <input type="text" inputMode="decimal" value={liveEditIdx.weight%1===0?String(liveEditIdx.weight):liveEditIdx.weight.toFixed(1)}
                          onChange={ev=>{const v=parseFloat(ev.target.value);if(!isNaN(v)&&v>=0)setLiveEditIdx(p=>({...p,weight:v}));}}
                          onFocus={ev=>ev.target.select()}
                          style={{width:"6ch",minWidth:0,flexShrink:0,background:"transparent",border:"none",borderBottom:`1px solid ${C.accent}`,color:C.accent,fontSize:16,fontWeight:800,textAlign:"center",outline:"none"}}/>
                        <button onClick={()=>setLiveEditIdx(p=>({...p,weight:parseFloat((p.weight+2.5).toFixed(1))}))} style={{width:28,height:28,borderRadius:8,background:C.faint,border:`1px solid ${C.border}`,color:C.accent,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,flexShrink:0}}>+</button>
                        <span style={{color:C.muted,fontSize:11,flexShrink:0}}>kg</span>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6}}>
                      <button onClick={()=>{
                        setDone(prev=>{const nx={...prev},arr=[...(nx[ex.name]||[])];arr[si]={reps:liveEditIdx.reps,weight:liveEditIdx.weight};nx[ex.name]=arr;return nx;});
                        setLiveEditIdx(null);
                      }} style={{flex:1,padding:"7px",background:C.accent,border:"none",borderRadius:8,color:"white",fontWeight:800,fontSize:12,cursor:"pointer"}}>✓ Valider</button>
                      <button onClick={()=>setLiveEditIdx(null)} style={{padding:"7px 14px",background:C.faint,border:`1px solid ${C.border}`,borderRadius:8,color:C.muted,fontWeight:700,fontSize:12,cursor:"pointer"}}>Annuler</button>
                    </div>
                  </div>
                );
              }
              return(
                <button key={si} onClick={()=>setLiveEditIdx({si,reps:d.reps,weight:d.weight})}
                  style={{display:"flex",alignItems:"center",gap:10,padding:"9px 13px",background:C.card,borderRadius:11,border:`1px solid ${C.border}`,cursor:"pointer",textAlign:"left",width:"100%"}}>
                  <div style={{width:22,height:22,borderRadius:"50%",background:C.accent,color:"white",display:"flex",alignItems:"center",justifyContent:"center",padding:0,lineHeight:1,fontSize:11,fontWeight:900,flexShrink:0}}>✓</div>
                  <span style={{color:C.muted,fontSize:12,flex:1}}>Série {si+1}</span>
                  <span style={{color:C.text,fontWeight:700,fontSize:14}}>{d.reps} reps</span>
                  {d.weight>0&&<span style={{color:C.accent,fontWeight:800,fontSize:14,marginLeft:6}}>{d.weight} kg</span>}
                  <span style={{color:C.muted,fontSize:13}}>✎</span>
                </button>
              );
            })}
          </div>
        </div>
      )}

      </div>
    </div>
  );
}
// ─── TABATA RUN PAGE ──────────────────────────────────────────────────────────
const INTERVALS = [
  {id:"20-10",label:"20s – 10s",work:20,rest:10},
  {id:"30-30",label:"30s – 30s",work:30,rest:30},
  {id:"40-20",label:"40s – 20s",work:40,rest:20},
  {id:"45-15",label:"45s – 15s",work:45,rest:15},
  {id:"50-10",label:"50s – 10s",work:50,rest:10},
  {id:"custom",label:"Personnalisé",work:30,rest:15},
];


export { RestTimer, SetModal, AddCustomExModal, ExPicker, SessionPage };
